export default ".card.card-container.card-marketplace {\n  box-shadow: var(--shadow-sm);\n}";